const KSUID = require('ksuid') // check https://segment.com/blog/a-brief-history-of-the-uuid/ for more info why key sortable uid are better
const getUid = () => KSUID.randomSync().string
export default getUid
